import _ from 'lodash'
import checkPermisison from '../utils/hasPermission'

export const getAllUsers = (state) => _.get(state, 'user.users', [])
export const getCurrentUser = (state) => _.get(state, 'user.currentUser', {})
export const getCurrentUserPermissions = (state) => {
  return _.get(getCurrentUser(state), 'permissions', [])
}

export const hasPermission = (state, requiredPermissions) => {
  const permissions = getCurrentUserPermissions(state)
  return checkPermisison(permissions, requiredPermissions)
}

export const canInviteUsers = (state) => {
  return hasPermission(state, ['user_invite'])
}

export const canDeleteUsers = (state) => {
  return hasPermission(state, ['user_delete'])
}

export const canEditUsers = (state) => {
  return hasPermission(state, ['user_write'])
}

export const canModifyAccountSettings = (state) => {
  return hasPermission(state, ['account_settings_modify'])
}

export const canModifyDeveloperSettings = (state) => {
  return hasPermission(state, ['developer_settings_modify'])
}
